import { type ReactNode } from "react";

import { Box } from "ui/box/box";

import {
  CONTENT_SX,
  CRITICAL_ICON_SX,
  ICON_SX,
  LABEL_GROUP_SX,
  LABEL_SX,
} from "ui/actions-menu/menu-item/menu-item.styles";

type MenuItemContentProps = {
  icon?: ReactNode;
  label: string;
  isCritical: boolean;
  trailing?: ReactNode;
};

export const MenuItemContent = ({ icon, label, isCritical, trailing }: MenuItemContentProps) => (
  <Box sx={CONTENT_SX}>
    <Box component="span" sx={LABEL_GROUP_SX}>
      {icon ? (
        <Box component="span" aria-hidden="true" sx={isCritical ? CRITICAL_ICON_SX : ICON_SX}>
          {icon}
        </Box>
      ) : null}
      <Box component="span" sx={LABEL_SX}>
        {label}
      </Box>
    </Box>
    {trailing}
  </Box>
);
